import script from "./EventCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EventCard.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/eventsExplorer.sass?vue&type=style&index=0&id=0c49e87c&scoped=true&lang=sass"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c49e87c"]])

export default __exports__